import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import FilterCheckedCheckBox from 'src/assets/images/FilterCheckedCheckBox.svg';
import FilterUncheckedCheckBox from 'src/assets/images/FilterUncheckedCheckBox.svg';
import RadioButtonActive from 'src/assets/images/RadioButton.svg';
import RadioButtonInactive from 'src/assets/images/RadioButtonInactive.svg';
import {
    FilterComponentSelector,
    FilterComponentLabels,
    FilterLabel,
    FilterCheckbox,
    CheckBox,
    RadioButton,
    OrderStatusIcons,
    DefaultIndicator,
    LineSeparator,
} from './CommonRadioCheckboxFilter.styled';

const CommonRadioCheckboxFilter = ({
    isRadio = false,
    isCheckbox = false,
    children,
    filterItem,
    filterItemRadio,
    filterItemId,
    iconUrl,
    isAdmin,
    onCheckBoxChange,
    checkBoxName,
    isChecked,
    labelWidth,
    width,
    labelResponsiveWidth,
    isDefault,
    labelMbWidth,
    lastElement,
    orderType,
    fontSize,
    fontFamily,
    fontColor,
    isShare,
    setSelectedCalendarView,
    radioName,
    whiteSpace,
    overFlow,
    textOverflow,
    index,
    FiltersListslength,
    paddingBottom,
    smbWidth,
    NoCaseCoversion=false
}) => {
    const { t } = useTranslation();
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );

    const filterItemName = filterItem?.toLowerCase();

    return (
        <>
            <FilterComponentSelector
                isRadio={isRadio}
                isCheckbox={isCheckbox}
                marginBottom={lastElement === (filterItem || filterItemRadio) ? '15px' : null}
                paddingBottom={
                    FiltersListslength == index ? paddingBottom : null
                }
            >
                <FilterComponentLabels
                    isRadio={isRadio}
                    isCheckbox={isCheckbox}
                    htmlFor={
                        isCheckbox ? `${filterItemId}` : `${radioName}-${filterItemRadio.id}`
                    }
                    leftPadding={isCheckbox ? '15px' : '0px'}
                    labelResponsiveWidth={labelResponsiveWidth}
                    onClick={isRadio && setSelectedCalendarView ? (e) => {
                        e.preventDefault();
                        setSelectedCalendarView(filterItemRadio, radioName);
                    } : undefined}
                >
                    {isCheckbox && (
                        <>
                            {isAdmin ? (
                                <FilterCheckbox
                                    type="checkbox"
                                    id={`${filterItemId}`}
                                    name={checkBoxName}
                                    value={`${filterItemId}`}
                                    onChange={(event) => {
                                        onCheckBoxChange(event, filterItem);
                                    }}
                                    checked={isChecked}
                                    data-testid="filter-checkbox"
                                />
                            ) : (
                                <FilterCheckbox
                                    type="checkbox"
                                    id={`${filterItemId}`}
                                    name={checkBoxName}
                                    value={`${filterItemId}`}
                                    onChange={(event) => {
                                        // handleCheckBoxChange(e);
                                        //onCheckBoxChange(event, checkBoxName);
                                        onCheckBoxChange(
                                            event,
                                            checkBoxName,
                                            !isChecked,
                                            filterItem,
                                            filterItemId
                                        );
                                    }}
                                    checked={isChecked}
                                    data-testid="filter-checkbox"
                                    // checked={checked}
                                />
                            )}
                            <CheckBox
                                src={
                                    isChecked
                                        ? FilterCheckedCheckBox
                                        : FilterUncheckedCheckBox
                                }
                                rightMargin={'10px'}
                            ></CheckBox>
                            {(() => {
                                if (iconUrl)
                                    return (
                                        <OrderStatusIcons
                                            src={iconUrl}
                                        ></OrderStatusIcons>
                                    );
                            })()}
                            <FilterLabel
                                color="#00000"
                                isCheckbox={isCheckbox}
                                labelWidth={labelWidth}
                                labelMbWidth={labelMbWidth}
                                width={width}
                                fontSize={fontSize}
                                fontFamily={fontFamily}
                                fontColor={fontColor}
                            >
                                {children
                                    ? children
                                    : filterItem === 'All'
                                    ? t('common.allLabel')
                                    : orderType
                                    ? filterItemName === 'mast'
                                        ? filterItemName.toUpperCase()
                                        :NoCaseCoversion?filterItem: filterItemName
                                              ?.charAt(0)
                                              .toUpperCase() +
                                          filterItemName?.slice(1)
                                    : filterItem}
                            </FilterLabel>
                            {isDefault ? (
                                <DefaultIndicator
                                    width={isLanguageChanged && '63px'}
                                >
                                    {t(
                                        'scheduleSurgery.Shipping.TissueServices.default'
                                    )}
                                </DefaultIndicator>
                            ) : null}
                        </>
                    )}
                    {isRadio && (
                        <>
                            <input
                                type="radio"
                                id={`${radioName}-${filterItemRadio.id}`}
                                name={radioName || 'Calendar View'}
                                value={`${filterItemRadio.name}`}
                                checked={isChecked}
                                onChange={() => {
                                    setSelectedCalendarView(
                                        filterItemRadio,
                                        radioName
                                    );
                                }}
                                style={{ display: 'none' }}
                                data-testid="calendar-radio"
                            ></input>
                            <RadioButton
                                src={
                                    isChecked
                                        ? RadioButtonActive
                                        : RadioButtonInactive
                                }
                                loading="eager"
                            />
                            {children ? (
                                children
                            ) : (
                                <>
                                    <FilterLabel
                                        isRadio={isRadio}
                                        color="#00000"
                                        width={width}
                                        smbWidth={smbWidth}
                                        whiteSpace={whiteSpace}
                                        overFlow={overFlow}
                                        textOverflow={textOverflow}
                                    >
                                        {filterItemRadio.name === 'All'
                                            ? t('common.allLabel')
                                            : filterItemRadio.name}
                                    </FilterLabel>
                                    {(() => {
                                        if (isDefault) {
                                            return (
                                                <DefaultIndicator
                                                    width={
                                                        isLanguageChanged &&
                                                        '53px'
                                                    }
                                                >
                                                    {t('filter.defaultLabel')}
                                                </DefaultIndicator>
                                            );
                                        } else {
                                            return <></>;
                                        }
                                    })()}
                                </>
                            )}
                        </>
                    )}
                </FilterComponentLabels>
                <br />
            </FilterComponentSelector>
            {isCheckbox &&
                (lastElement === filterItem || isShare ? null : (
                    <LineSeparator />
                ))}
            {isRadio &&
                (FiltersListslength ? (
                    FiltersListslength !== index && <LineSeparator />
                ) : (
                    <LineSeparator />
                ))}
        </>
    );
};

export default CommonRadioCheckboxFilter;
